export let WixComponentTypes = /*#__PURE__*/function (WixComponentTypes) {
  WixComponentTypes["classic"] = "wix_classic";
  WixComponentTypes["studio"] = "wix_studio";
  WixComponentTypes["payments"] = "wix_payments";
  WixComponentTypes["rise"] = "rise";
  return WixComponentTypes;
}({});
//# sourceMappingURL=types.js.map